import { Link, useLocation } from "react-router-dom";

function NavItem({ path, label, onClick }) {
  const { pathname } = useLocation();
  const isActive = pathname === path;

  return (
    <Link
      to={path}
      onClick={onClick}
      className={`block px-4 py-2 text-sm rounded-lg transition-colors duration-150 ${
        isActive
          ? "bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 font-medium"
          : "text-text-secondary hover:text-text-primary hover:bg-bg-secondary"
      }`}
    >
      {label}
    </Link>
  );
}

export default NavItem;
